// @ts-nocheck
import { cAPI } from '../../../utils/cAPI';
import { addEditData, getData } from '../generic';
import { setForceRefetchByTarget } from '../../../features/refetchers/slice';

export const getAllPermissions = () => dispatch => getData(dispatch, cAPI.APGetAllPermissions, null, 'permissions');
export const updatePermissions = modifications => async dispatch => {
	const result = await addEditData(dispatch, cAPI.APUpdatePermissions, modifications, 'permissions');
	// Ensure refetch flag is set even when API returns no payload
	dispatch(setForceRefetchByTarget({ target: 'permissions', forceRefetch: true }));
	return result;
};
export const getRole = id => dispatch => getData(dispatch, cAPI.APGetRole, id, 'permissions');
export const updateRole = formData => dispatch => addEditData(dispatch, cAPI.APEditRole, formData, 'permissions');
export const deleteRole = id => dispatch => addEditData(dispatch, cAPI.APDeleteRole, { id }, 'permissions');
